const appendScript = ({ src, async = true, crossOrigin, parent = document.body }) => {
  if (!src || typeof document === "undefined") return null;

  const script = document.createElement("script");
  script.src = src;
  script.async = async;
  if (crossOrigin) {
    script.crossOrigin = crossOrigin;
  }

  parent.appendChild(script);
  return script;
};

const BOOTSTRAP_SCRIPT = {
  src: "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js",
  crossOrigin: "anonymous",
};

const DELAYED_SCRIPTS = [
  {
    src: "https://static.hotjar.com/c/hotjar-2987017.js?sv=6",
    crossOrigin: "anonymous",
  },
];

const HOTJAR_SETTINGS = { hjid: 2987017, hjsv: 6 };

const ensureDataLayer = () => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
  }
};

const ensureHotjarSettings = () => {
  if (typeof window !== "undefined") {
    (window._hjSettings ||= HOTJAR_SETTINGS);
  }
};

export const loadThirdPartyScripts = () => {
  if (typeof window === "undefined") {
    return () => {};
  }

  ensureHotjarSettings();
  appendScript(BOOTSTRAP_SCRIPT);
  ensureDataLayer();

  const timerId = window.setTimeout(() => {
    DELAYED_SCRIPTS.forEach((script) => appendScript(script));
  }, 3000);

  return () => {
    window.clearTimeout(timerId);
  };
};

const C2AI_SCRIPT = {
  src: "https://c2ai.chat/chat.js?user_id=80",
  crossOrigin: "anonymous",
};

let c2aiScriptAppended = false;

export const loadC2aiOnInteraction = () => {
  if (c2aiScriptAppended || typeof window === "undefined") {
    return;
  }

  appendScript(C2AI_SCRIPT);
  c2aiScriptAppended = true;
};

const GTM_SCRIPT = {
  src: "https://www.googletagmanager.com/gtm.js?id=GTM-NR8G8XD",
  crossOrigin: "anonymous",
};

let gtmScriptAppended = false;

export const loadGtmOnInteraction = () => {
  if (gtmScriptAppended || typeof window === "undefined") {
    return;
  }

  appendScript(GTM_SCRIPT);
  gtmScriptAppended = true;
};

export const installThirdPartyErrorSuppressor = () => {
  if (typeof window === "undefined") {
    return () => {};
  }

  const handleError = (event) => {
    if (
      event?.message === "Script error." &&
      event?.target instanceof HTMLScriptElement
    ) {
      event.preventDefault();
    }
  };

  window.addEventListener("error", handleError, true);

  return () => {
    window.removeEventListener("error", handleError, true);
  };
};
